import { updateFriendInCache } from "@/entities/friend"
import { showNotification } from "@/entities/notification"
import { registerNotification } from "@/shared/api/websocket"
import { isActiveBoardUser } from "@/shared/lib/active-board"

registerNotification("friend_message", {
	handle: ({ notification_id, data }, ctx) => {
		showNotification({
			type: "silent",
			placement: null,
			origin: "server",
			notificationId: notification_id,
			name: "friend_message",
		})
		if (!data.is_friend || isActiveBoardUser(data.friend_id)) return

		updateFriendInCache(
			ctx.queryClient,
			ctx.userId,
			data.friend_id,
			(friend) => ({
				...friend,
				unread_board: true,
			}),
		)
	},
	// A message from someone who is not a friend yet has no board to open: the
	// proposal popup on the home screen is where it is answered.
	route: ({ data }) => {
		if (data.is_friend) {
			return {
				to: "/board/friend/$friendId",
				params: { friendId: data.friend_id },
			}
		}
		return { to: "/home" }
	},
	routePopup: null,
})
